module.exports = __webpack_public_path__ + "static/DUC_8406_square-599decd11ab2019efa2bc115beed3f5f.jpeg";